module.exports = __webpack_public_path__ + "static/img/2025-07-4.b4798c27.png";